import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const LegalEntityRepresentative = () => {
  return (
    <Flow>
      <Flow.Progress label='Cadastro do procurador' />

      <Flow.StepList>
        <Step name='social-contract-representative' />
        <Step name='face-detection' />
        <Step name='document-representative' />
        <Step name='representative-document-file' />
        <Step name='phone-representative' />
        <Step name='address' />
        <Step name='occupation-representative' />
        <Step name='income-representative' />
        <Step name='legal-entity-income' />
        <Step name='pep-representative' />
        <Step name='bank-account' />
        <Step name='terms' />
      </Flow.StepList>
    </Flow>
  );
};
